/**
 * PeriodSelector Component
 * 
 * Reusable month/year selector with chip-style buttons.
 */

import React from 'react';

export interface PeriodSelectorProps {
  month: number;
  year: number;
  onMonthChange: (month: number) => void;
  onYearChange: (year: number) => void;
  yearRange?: number;
  className?: string;
}

const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  month,
  year,
  onMonthChange,
  onYearChange,
  yearRange = 3,
  className = '',
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: yearRange * 2 + 1 },
    (_, i) => currentYear - yearRange + i
  );

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {/* Year Selector */}
      <div className="flex flex-wrap gap-2">
        {years.map((y) => (
          <button
            key={y}
            onClick={() => onYearChange(y)}
            className={`
              px-4 py-2 rounded-full text-sm font-medium transition-all
              ${year === y
                ? 'bg-[#c00035] text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }
            `}
          >
            {y}
          </button>
        ))}
      </div>

      {/* Month Selector */}
      <div className="flex flex-wrap gap-2">
        {MONTHS.map((m, index) => (
          <button
            key={m}
            onClick={() => onMonthChange(index + 1)}
            className={`
              px-3 py-1.5 rounded-full text-sm font-medium transition-all
              ${month === index + 1
                ? 'bg-[#c00035] text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }
            `}
          >
            {m}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PeriodSelector;

